import { 
    distanceBetweenDots, 
    distanseBetweenLayers, 
    dotDiametr, 
    getCenteredCoordinateForAnimation, 
    BallPositionByDot, 
    parabolic,
    MINI_BOUNCE_ANIMATION_TIME,
    JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME
 } from '../../initials';
export class JumpFromDotToDotWithMiniBounce {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'JumpFromDotToDotWithMiniBounce',
            fromBallPositionByDot: BallPositionByDot.CENTER,
            toBallPositionByDot: BallPositionByDot.CENTER,
        };
    }

    getAnimationTime() {
        return MINI_BOUNCE_ANIMATION_TIME + JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME;
    }

    animate(time) {

        const isLeftMovement = this.fromDotIndex >= this.toDotIndex;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getCenteredCoordinateForAnimation(startDot.dotX, startDot.dotY);
        const endXY = getCenteredCoordinateForAnimation(endDot.dotX, endDot.dotY);

        const firstPartEndX = isLeftMovement ? startXY.x - dotDiametr * 0.5 : startXY.x + dotDiametr * 0.5;

        if (time < MINI_BOUNCE_ANIMATION_TIME) {
            const t = time / MINI_BOUNCE_ANIMATION_TIME;

            return {
                    x: parabolic(
                        startXY.x,
                        isLeftMovement ? startXY.x - dotDiametr * 0.25 : startXY.x + dotDiametr * 0.25,
                        firstPartEndX,
                        t
                    ),
                    y: parabolic(
                        startXY.y,
                        startXY.y - distanseBetweenLayers / 4,
                        startXY.y,
                        t
                    )
                };
        }

        const t = (time - MINI_BOUNCE_ANIMATION_TIME) / JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME;

        return {
            x: parabolic(
                firstPartEndX,
                isLeftMovement ? firstPartEndX - distanceBetweenDots / 2 : firstPartEndX + distanceBetweenDots / 2,
                endXY.x,
                t,
            ),
            y: parabolic(
                startXY.y,
                startDot.dotY - distanseBetweenLayers,
                endXY.y,
                t,
            )
        };
    }
}